import type { ApexOptions } from 'apexcharts'
import type { VideosTimeSeriesData } from '../../../features/engagement/domain/models/videos'
import { buildLineChartOptions, EngagementChartColors, longDateFormatter, type ChartSeriesItem } from '../charts'

export interface VideosLegendState {
  [key: string]: boolean
  timesViewed: boolean
  uniqueViewers: boolean
}

export interface VideosLegendItem {
  key: string
  label: string
  color: string
}

export const VIDEOS_LEGEND_ITEMS: VideosLegendItem[] = [
  { key: 'timesViewed', label: 'Videos: Total Times Viewed', color: EngagementChartColors.primary },
  { key: 'uniqueViewers', label: 'Videos: Unique Viewers', color: EngagementChartColors.secondary }
]

export const VIDEOS_INITIAL_LEGEND_STATE: VideosLegendState = {
  timesViewed: true,
  uniqueViewers: true
}

export const getVideosChartOptions = (data: VideosTimeSeriesData[], legend: VideosLegendState): ApexOptions => {
  const categories = data.map((d) => d.date)

  const series: ChartSeriesItem[] = []

  if (legend.timesViewed) {
    series.push({
      name: 'Videos: Total Times Viewed',
      data: data.map((d) => d.timesViewed),
      color: EngagementChartColors.primary
    })
  }

  if (legend.uniqueViewers) {
    series.push({
      name: 'Videos: Unique Viewers',
      data: data.map((d) => d.uniqueViewers),
      color: EngagementChartColors.secondary
    })
  }

  return buildLineChartOptions({
    series,
    categories,
    tooltipHeaderFormatter: longDateFormatter
  })
}
